import { render, staticRenderFns } from "./DistributionScheme.vue?vue&type=template&id=780ead94&scoped=true&"
import script from "./DistributionScheme.vue?vue&type=script&lang=js&"
export * from "./DistributionScheme.vue?vue&type=script&lang=js&"
import style0 from "./DistributionScheme.vue?vue&type=style&index=0&id=780ead94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ead94",
  null
  
)

export default component.exports